import React from "react";

export default function ClassSpecificInfoItems({ currentIssue, observation }) {
    const items = [];

    if (currentIssue.class === "Tensioner" && "overlay_data" in observation && "temperature_celsius" in observation.overlay_data) {
        items.push(
            <div className="InfoItem">
                <div className="TitleContainer">
                    <p className="Title">Temperature</p>
                </div>
                <div className="InfoValues">
                    <p className="InfoText">
                        <span>{observation.overlay_data.temperature_celsius}°C</span>
                    </p>
                </div>
            </div>,
        );
    }

    return items;
}
